import { Component, OnInit } from '@angular/core';
import { NpsService } from 'src/app/services/nps.service';
import { PersianDate } from 'src/app/core/persian-date';
import { Guid } from 'src/app/core/common';

@Component({
  selector: 'app-nps-report',
  templateUrl: './nps-report.component.html',
  styleUrls: ['./nps-report.component.scss']
})
export class NpsReportComponent implements OnInit {
  Guid = Guid;
  constructor(private npsService: NpsService) { }

  async ngOnInit() {
    await this.load();
  }

  criteria: any = {
    from: new PersianDate().addDay(-1).toGregorian(),
    to: new Date(),
    minScore: 1,
    maxScore: 10
  }

  result: any;

  async load() {
    delete this.result;
    this.result = await this.npsService.report(this.criteria);
  }

  async star(nps: any) {
    nps.IsStarred = !nps.IsStarred;
    await this.npsService.setIsStarred(nps.Id, nps.IsStarred);
  }

}
